<template>
  <path :d="pathDescription"
    fill="none"
    :stroke="conversion.bAB === true ? '#1199af' : '#9fce12'"
    :stroke-width="strokeWidth"
    :stroke-dasharray="strokeWidth === 1 ? '3,2' : ''"/>
</template>
<script>
export default {
  name: 'BaNodePath',
  components: {
  },
  props: [
    'conversion',
    'sequenceIndex',
    'length',
    'strokeWidth',
    'groupHeight',
    'divisionHeight',
    'APrev',
    'BPrev',
    'AHeight',
    'BHeight'
  ],
  data () {
    return {
    }
  },
  computed: {
    pathDescription () {
      let middleA = (this.divisionHeight / 2) - (32 - 6) - (this.AHeight + (19 - this.AHeight / 2))
      let middleB = (this.divisionHeight / 2) + (32 + 6) + (19 - this.BHeight / 2)
      let fromX = 0
      let prevHeight = this.groupHeight.length > 0
        ? this.groupHeight.filter((item, idx) => idx < this.sequenceIndex).reduce((prev, cur) => { return prev + cur }, 0)
        : 0
      let prevAHeight = this.APrev.length > 0
        ? this.APrev.filter((item, idx) => idx < this.sequenceIndex).reduce((prev, cur) => { return prev + cur }, 0)
        : 0
      let prevBHeight = this.BPrev.length > 0
        ? this.BPrev.filter((item, idx) => idx < this.sequenceIndex).reduce((prev, cur) => { return prev + cur }, 0)
        : 0
      let fromY = this.conversion.bAB === true ? middleB + (this.strokeWidth / 2) + prevBHeight : middleA + (this.strokeWidth / 2) + prevAHeight
      let toX = 300
      let toY = this.groupHeight.length > 0 ? this.conversion.bAB === false
        ? prevHeight + (this.groupHeight[this.sequenceIndex] / 2) - (this.strokeWidth / 2)
        : prevHeight + (this.groupHeight[this.sequenceIndex] / 2) + (this.strokeWidth / 2)
        : 0
      const centerX1 = 150
      const centerX2 = 150
      const description = []
      description.push(
        'M', fromX, fromY,
        'L', fromX + 60, fromY,
        'C', centerX1 + (this.strokeWidth * 2), fromY, centerX2 - (this.strokeWidth * 2), toY, toX - 20, toY,
        'L', toX, toY
      )
      return description.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped></style>
